<template>
  <div class="login-container">
    <!-- <iframe width="100%" height="100%" src="https://ececloud.cn/organize/#/login" frameborder="0" /> -->
    <div class="login-l" />
    <div class="login-r">
      <div v-show="step === 0" class="login-box">
        <!-- <div class="login-logo">
          <img :src="loginLogo">
        </div> -->
        <h3 class="title">
          欢迎来到<br>
          朵步宝贝机构后台
        </h3>
        <!--密码登录-->
        <el-form
          v-show="loginType === 0"
          ref="loginForm"
          class="loginBox"
          auto-complete="on"
          label-position="left"
          label-width="0px"
          :rules="loginFormRules"
          :model="loginForm"
          @submit.native.prevent
        >
          <!--手机或邮箱-->
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              class="w-100"
              name="username"
              type="text"
              auto-complete="on"
              :maxlength="11"
              :placeholder="$t('Account')"
            />
          </el-form-item>
          <!--密码-->
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              class="w-100"
              name="password"
              type="password"
              show-password
              auto-complete="on"
              :placeholder="$t('Password')"
              show-message
              @keyup.enter.native="handleLogin"
            />
          </el-form-item>
          <el-row class="loginWay">
            <el-col :span="12">
              <a class="code-btn" @click="changeLoginWay(1)">{{
                $t('LoginByCaptcha')
              }}</a>
            </el-col>
            <el-col :span="12" class="tr">
              <a @click="forgetPassword">{{ $t('ForgetPassword') }}</a>
            </el-col>
          </el-row>
          <!--登录button-->
          <el-form-item class="button-row">
            <button-async :on-click="handleLogin" class="w-100" type="primary">
              {{ $t('Login') }}
            </button-async>
          </el-form-item>
        </el-form>
        <!-- 验证码登录 -->
        <el-form
          v-show="loginType === 1"
          ref="codeLoginForm"
          class="loginBox"
          label-position="left"
          label-width="0px"
          :rules="codeLoginFormRules"
          :model="codeLoginForm"
        >
          <!-- 手机 -->
          <el-form-item prop="username">
            <el-row>
              <el-col :span="16">
                <el-input
                  v-model="codeLoginForm.username"
                  name="username"
                  type="text"
                  :placeholder="$t('Phone')"
                />
              </el-col>
              <el-col :span="8">
                <el-button
                  type="primary"
                  class="codeBtn w-100"
                  :class="{disabledBtn: disabled}"
                  @click="getCaptcha(101)"
                >
                  {{ btnText }}
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <!-- 验证码 -->
          <el-form-item prop="captcha">
            <el-input
              v-model="codeLoginForm.captcha"
              name="password"
              class="w-100"
              auto-complete="on"
              :placeholder="$t('CheckCode')"
              show-message
            />
          </el-form-item>
          <el-row class="loginWay">
            <el-col :span="12">
              <a @click="changeLoginWay(0)">{{ $t('LoginByPassword') }}</a>
            </el-col>
            <el-col :span="12" class="text-right" />
          </el-row>
          <!-- 登录button -->
          <el-form-item class="button-row">
            <button-async
              style="width: 100%"
              type="primary"
              :on-click="captchaLogin"
            >
              {{ $t('Login') }}
            </button-async>
          </el-form-item>
        </el-form>
      </div>
      <!--忘记密码-->
      <div v-show="step === 1" class="login-box forgetBox">
        <h3>{{ $t('ForgetPassword') }}</h3>
        <el-form
          ref="forgetForm"
          class="forgetForm mt30"
          :rules="forgetFormRules"
          :model="forgetForm"
        >
          <el-form-item prop="username">
            <!-- <span class="login-user-box" /> -->
            <el-input
              v-model="forgetForm.username"
              :maxlength="11"
              class="w-100"
              :placeholder="$t('Phone')"
            />
          </el-form-item>
          <el-row>
            <el-col :span="16">
              <el-form-item prop="captcha">
                <!-- <span class="login-code-box" /> -->
                <el-input
                  v-model="forgetForm.captcha"
                  class="w-100"
                  :placeholder="$t('CheckCode')"
                />
              </el-form-item>
            </el-col>
            <el-col class="text-right" :span="8">
              <el-button
                type="primary"
                class="forgetBtn forgetCodeBtn"
                :class="{disabledBtn: forgetDisabled}"
                @click="getCaptcha(102)"
              >
                {{ forgetBtnText }}
              </el-button>
            </el-col>
          </el-row>
          <button-async
            class="wth370 forgetBtn"
            size="medium"
            type="primary"
            :on-click="checkCodeSubmit"
          >
            {{ $t('Next') }}
          </button-async>
          <el-button class="back-btn" @click="goBack(0)">
            {{ $t('Back') }}
          </el-button>
          <!-- <p class="text-center mt30">
            <a class="c-theme" @click="goBack(0)">{{ $t('Back') }}</a>
          </p> -->
        </el-form>
      </div>
      <!--重置密码-->
      <div v-show="step === 2" class="login-box forgetBox">
        <h3>{{ $t('ResetPassword') }}</h3>
        <el-form
          ref="resetForm"
          class="forgetForm mt30"
          :model="resetForm"
          :rules="resetFormRules"
        >
          <el-form-item prop="password">
            <!-- <span class="login-code-box" /> -->
            <el-input
              v-model="resetForm.password"
              type="password"
              class="w-100"
              show-password
              :placeholder="$t('NewPassword')"
            />
          </el-form-item>
          <el-form-item prop="confirmPassword">
            <!-- <span class="login-code-box" /> -->
            <el-input
              v-model="resetForm.confirmPassword"
              class="w-100"
              type="password"
              show-password
              :placeholder="$t('ConfirmPassword')"
            />
          </el-form-item>
          <button-async
            class="wth370 forgetBtn"
            :on-click="resetFormSubmit"
            type="primary"
          >
            {{ $t('Confirm') }}
          </button-async>
          <!-- <p class="text-center mt30">
            <a class="c-theme" @click="goBack(1)">{{ $t('Back') }}</a>
          </p> -->
          <el-button class="back-btn" @click="goBack(1)">
            {{ $t('Back') }}
          </el-button>
        </el-form>
      </div>

      <div v-show="step === 4" class="login-box">
        <h3 class="title">选择机构</h3>
        <div v-for="(v,index) in organizeList" :key="index" class="choice-row mt30" @click="chooseLogin(v)">
          <img src="../../img/login/ys.png">
          <div class="name">{{ v.name }}</div>
          <div class="tip" :class="{'jg-tip': v.OrganizeTypeIntro === '机构'}">{{ v.OrganizeTypeIntro }}</div>
        </div>
        <!-- <div class="choice-row mt20">
          <img src="../../img/login/jg.png">
          <div class="name">智晗幼儿园</div>
          <div class="tip jg-tip">机构</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import loginLogo from '@/assets/images/login/logo@2x.png'
import { captcha, validatePassword, validateCaptcha, forgetPassword, organizeLoginVos, authLogin } from '@/api/user'
// import { getCode, validatePassword, forgetPassword } from '@/api/account'
// import { setToken } from '@/utils/auth'
// import { getStore, setStore } from '@/utils'
import { isPhone } from '@/utils/validate'

import md5 from 'js-md5'

export default {
  name: 'Login',
  data() {
    return {
      // roles: this.$store.state.enums.enumsList.roles,
      step: 0,
      loginLogo: loginLogo,
      loginType: 0,
      loginForm: {
        username: '',
        password: ''
      },
      loginFormRules: {
        username: { validator: this.checkUserName, trigger: 'blur' },
        password: { required: true, message: this.$t('PleaseInput') }
      },
      codeLoginForm: {
        username: '',
        captcha: ''
      },
      codeLoginFormRules: {
        username: { required: true, validator: this.checkPhone, trigger: 'blur' },
        captcha: { required: true, message: this.$t('PleaseInput'), trigger: 'blur' }
      },
      loading: false,
      disabled: false,
      btnText: this.$t('GetCode'),
      forgetPasswordDialog: true,
      forgetDisabled: false,
      forgetBtnText: this.$t('GetCode'),
      forgetForm: {
        username: '',
        captcha: ''
      },
      forgetFormRules: {
        username: { required: true, validator: this.checkPhone, trigger: 'blur' },
        captcha: { required: true, message: this.$t('PleaseInput'), trigger: 'blur' }
      },
      resetForm: {
        password: '',
        confirmPassword: ''
      },
      resetFormRules: {
        password: { required: true, message: this.$t('PleaseInput'), trigger: 'blur' },
        confirmPassword: {
          required: true,
          validator: this.checkConfirmPassword
        }
      },
      telPhone: '',
      organizeList: []
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      // this.$store.commit('SET_ROLE', 101)
    },
    // handleTabChange(code){
    //   this.$store.commit('SET_ROLE', code)
    //   // 为了重新初始化axios 变更接口地址
    //   window.location.reload()
    // },
    chooseLogin(v) {
      authLogin({
        organizeId: v.organizeId,
        organizeType: v.organizeType,
        teacherId: v.teacherId
      }).then(res => {
        this.$store.commit('SET_TOKEN', res.data.token)
        this.$store.commit('SET_ORGANIZE_ID', res.data.organizeId)
        this.$store.commit('SET_CAMPUS_ID', res.data.campusId || res.data.id)
        this.$store.commit('SET_ORGANIZETYPE', v.organizeType)
        this.$router.push('/')
      })
    },
    handleLogin() {
      let promise = null
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          // promise = this.$store
          //   .dispatch('Login', this.loginForm)
          //   .then(() => {
          //     this.step = 4
          //     // this.$router.push('/')
          //   })
          //   .catch(() => { })
          let { username, password } = this.loginForm
          username = username.trim()
          password = md5(password)
          promise = organizeLoginVos({ username, password }).then(res => {
            this.organizeList = res.data.array
            this.step = 4
          })
        } else {
          return false
        }
      })
      return promise
    },
    changeLoginWay(type) {
      this.loginForm.username = ''
      this.loginForm.password = ''
      this.codeLoginForm.username = ''
      this.codeLoginForm.captcha = ''
      this.loading = false
      this.$refs.loginForm.resetFields()
      this.$refs.codeLoginForm.resetFields()
      this.loginType = type
    },
    /* 获取验证码 */
    getCodeFun(params, disabled, btnText) {
      if (this[disabled]) {
        return false
      } else {
        var GetCode = this.$t('GetCode')
        var ReSend = this.$t('ReSend')
        captcha(params)
          .then(result => {
            let second = 60
            this[disabled] = true
            this[btnText] = ReSend + '(' + second + ')'
            var timer = setInterval(() => {
              second -= 1
              if (second < 0) {
                this[disabled] = false
                this[btnText] = GetCode
                clearInterval(timer)
              } else {
                this[disabled] = true
                this[btnText] = ReSend + '(' + second + ')'
              }
            }, 1000)
          })
          .catch(() => { })
      }
    },
    getCaptcha(type) {
      if (type === 101) {
        // 登录
        this.$refs.codeLoginForm.validateField('username', err => {
          if (err) {
            return false
          } else {
            this.getCodeFun(
              {
                type: 101,
                phone: this.codeLoginForm.username
              },
              'disabled',
              'btnText'
            )
          }
        })
      }
      if (type === 102) {
        // 忘记密码
        this.$refs.forgetForm.validateField('username', err => {
          if (err) {
            return false
          } else {
            this.getCodeFun(
              {
                type: 102,
                phone: this.forgetForm.username
              },
              'forgetDisabled',
              'forgetBtnText'
            )
          }
        })
      }
    },
    /* 验证码登录 */
    captchaLogin() {
      let promise = null
      this.$refs.codeLoginForm.validate(valid => {
        if (valid) {
          // promise = this.$store
          //   .dispatch('CaptchaLogin', this.codeLoginForm)
          //   .then(result => {
          //     this.$router.push('/')
          //   })
          //   .catch(() => { })
          promise = organizeLoginVos(this.codeLoginForm).then(res => {
            this.organizeList = res.data.array
            this.step = 4
          })
        } else {
          return false
        }
      })
      return promise
    },
    /* 检查手机号 */
    checkPhone(rule, value, callback) {
      if (!value) {
        return callback(new Error(this.$t('PleaseInput')))
      }
      const telReg = isPhone(value)
      if (!telReg) {
        return callback(new Error(this.$t('PhoneFormatError')))
      }
      callback()
    },
    /* 检查确认密码 */
    checkConfirmPassword(rule, value, callback) {
      if (!value) {
        return callback(new Error(this.$t('ConfirmPasswordRequired')))
      }
      if (value !== this.resetForm.password) {
        return callback(new Error(this.$t('ConfirmPasswordChecked')))
      }
      callback()
    },
    /* 检查用户名 */
    checkUserName(rule, value, callback) {
      if (!value) {
        return callback(new Error(this.$t('AccountRequired')))
      }
      const emailReg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
      const telReg = isPhone(value)
      if (!emailReg.test(value) && !telReg) {
        return callback(new Error(this.$t('CheckUserName')))
      }
      callback()
    },
    /* 忘记密码 */
    forgetPassword() {
      this.step = 1
    },
    /* 验证忘记密码 */
    checkCodeSubmit() {
      console.info(this.forgetForm)
      let promise = null
      this.$refs.forgetForm.validate(valid => {
        if (valid) {
          promise = validateCaptcha({
            phone: this.forgetForm.username,
            captcha: this.forgetForm.captcha,
            type: 102
          })
            .then(result => {
              this.step = 2
            })
            .catch(() => { })
        } else {
          return false
        }
      })
      return promise
    },
    /* 返回 */
    goBack(step) {
      this.$refs.loginForm.resetFields()
      this.$refs.codeLoginForm.resetFields()
      this.$refs.forgetForm.resetFields()
      this.$refs.resetForm.resetFields()
      this.step = step
    },
    /* 重置密码 */
    resetFormSubmit() {
      let promise = null
      this.$refs.resetForm.validate(valid => {
        if (valid) {
          promise = forgetPassword({
            password: md5(this.resetForm.password),
            phone: this.forgetForm.username
          })
            .then(result => {
              this.$notify({
                title: '成功',
                message: '修改成功，请重新登录',
                type: 'success',
                duration: 3000
              })
              this.goBack(0)
            })
            .catch(() => { })
        } else {
          return false
        }
      })
      return promise
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" type="text/scss">
@import 'src/styles/_mixins.scss';
$bg: #283443;
$light_gray: #fff;
$dark_gray: #889aa4;
$cursor: #fff;
// @supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
//   .login-container .el-input input {
//     color: $cursor;
//   }
// }

/* reset element-ui css */
.login-container {
  @include relative;
  // height: 100vh;
  // background: url('../../img/login/bg.png') no-repeat;
  // background-size: cover;
  // background-position: center;
  background: #ffffff;
  .codeBtn {
    height: 48px;
  }
  .back-btn {
    height: 48px;
    width: 100%;
    margin-top: 10px;
    margin-left: 0;
  }
  .disabledBtn {
    background: #ffffff !important;
    color: #999999 !important;
    border: 1px solid #dddddd !important;
    &:hover {
      border: 1px solid #dddddd !important;
    }
  }
  .login-l {
    background: url('../../img/login/bg.png') no-repeat;
    background-size: cover;
    width: 40%;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
  }
  .login-r {
    width: 60%;
    height: 100vh;
    position: absolute;
    left: 40%;
    top: 0;
  }
  .login-box {
    background: #ffffff;
    // border: 1px solid #cccccc;
    border-radius: 8px;
    width: 400px;
    position: absolute;
    top: 50%;
    left: 50%;
    // margin-top: -246px;
    // margin-left: -214px;
    transform: translate(-50%, -50%);
    padding: 0 30px;
    box-sizing: border-box;
    // box-shadow: 0px 0px 15px 0px rgba(115, 115, 115, 0.2);
    .choice-row {
      background: #ffffff;
      border-radius: 10px;
      border: 1px solid #dddddd;
      padding: 15px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 50px;
      height: 80px;
      position: relative;
      cursor: pointer;
      &:hover {
        border: 1px solid #ff7145;
      }
      .tip {
        position: absolute;
        right: 15px;
        top: 30px;
        background: #fff1eb;
        border-radius: 4px;
        border: 1px solid #ffb999;
        font-size: 12px;
        font-weight: 400;
        color: #ff5100;
        line-height: 20px;
        width: 40px;
        height: 22px;
        text-align: center;
      }
      .jg-tip {
        border: 1px solid #97c3ff!important;
        background: #edf5ff!important;
        color: #1677ff!important;
      }
      img {
        height: 50px;
        width: 50px;
        float: left;
        margin-right: 15px;
      }
      .name {
        float: left;
      }
    }
    .title {
      font-size: 20px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
      letter-spacing: 1px;
      margin-top: 14px;
      margin-bottom: 41px;
      text-align: left;
    }
    .login-logo {
      text-align: center;
      margin-top: 54px;
      img {
        margin: 0 auto;
        width: 76px;
        height: 66px;
      }
    }
    .login-lang {
      border-top: 1px solid #dedfdf;
      text-align: center;
      line-height: 54px;
      height: 54px;
      font-size: 12px;
      .lang-chioce {
        margin-right: 8px;
        cursor: pointer;
        img {
          display: inline-block;
          width: 22px;
          height: 22px;
          vertical-align: middle;
        }
        span {
          color: #666666;
        }
      }
    }
    .login-user {
      background: url('../../assets/images/login/key@2x.png') no-repeat 50% 50%;
      background-size: 16px 16px;
      width: 48px;
      height: 48px;
      display: inline-block;
      float: left;
    }
    .login-user-box {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      background: url('../../assets/images/login/user.png') no-repeat 50% 50%
        #fafafa;
      background-size: 16px 16px;
      width: 48px;
      height: 48px;
      display: inline-block;
      float: left;
      border-right: 1px solid #dedfdf;
    }
    .login-code {
      background: url('../../assets/images/login/code.png') no-repeat 50% 50%;
      background-size: 16px 16px;
      width: 48px;
      height: 48px;
      display: inline-block;
      float: left;
    }
    .login-code-box {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      background: url('../../assets/images/login/code.png') no-repeat 50% 50%
        #fafafa;
      background-size: 16px 16px;
      width: 48px;
      height: 48px;
      display: inline-block;
      float: left;
      border-right: 1px solid #dedfdf;
    }
    .login-psw {
      background: url('../../assets/images/login/key@2x.png') no-repeat 50% 50%;
      background-size: 16px 16px;
      width: 48px;
      height: 48px;
      display: inline-block;
      float: left;
    }
  }
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
    -webkit-text-fill-color: #333 !important;
  }
  input {
    background: none !important;
    // border: 0px;
    -webkit-appearance: none;
    // border-radius: 0px;
    padding: 12px 5px 12px 15px;
    height: 48px !important;
    font-size: 14px !important;
    // border-top: none !important;
    // border-right: none !important;
    // border-bottom: none !important;
    &:-webkit-autofill {
      background-color: #ffffff !important;
    }
  }
  .el-form-item__content {
    width: 100%;
    .el-input__inner {
      border-radius: 10px;
      border: 1px solid #dddddd;
      // border: none !important;
    }
  }
  .button-row {
    margin-top: 35px;
    button {
      height: 50px;
      border-radius: 25px;
    }
  }
  .el-input {
    display: inline-block;
    height: 100%;
    width: 85%;
  }
  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;
  }
  .title {
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 40px;
    line-height: 25px;
  }
  .el-form-item {
    // border-bottom: 1px solid #dedfdf;
    border-radius: 5px;
    color: #454545;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
  }
}
.loginWay {
  font-size: 12px;
  color: #999;
  .code-btn {
    color: #2b89ff;
  }
}
.forgetBox {
  padding: 0 !important;
  overflow: hidden;
  h3 {
    line-height: 60px;
    text-align: center;
    // background: #f9f9f9;
    // border-bottom: 1px solid #cccccc;
  }
  .forgetForm {
    padding-bottom: 30px;
    margin: 0 auto;
    width: 370px;
    .el-form-item {
      // border: 1px solid #dedfdf;
    }
    .forgetCodeBtn {
      width: 112px !important;
      margin-left: 10px;
    }
    .forgetBtn {
      line-height: 20px;
      height: 48px;
    }
  }
}
.wth370 {
  width: 370px !important;
}
.wth194 {
  width: 194px !important;
}
.loginBox {
  .el-form-item {
    border-radius: 0px !important;
  }
}
</style>
<style lang="scss" scoped>
.tab {
  text-align: center;
  margin-top: 40px;
  .tab-item {
    display: inline-block;
    vertical-align: middle;
    margin: 0 20px;
    font-size: 20px;
    line-height: 28px;
    color: #999;
    cursor: pointer;
    &:after {
      content: '';
      display: block;
      margin: 0 auto;
      width: 0;
      transition: 0.1s;
      height: 4px;
      background-color: #f2cd00;
    }
    &.active {
      color: #333;
      &:after {
        width: 33px;
      }
    }
  }
}
</style>
